<template>
    <div style="width:100%; display:block">
        <ion-grid >
            <ion-row>
                <ion-col class="ion-text-left">
                    <ion-label position="static">Required: {{ line.qty_required }}</ion-label>
                </ion-col>
                <ion-col class="ion-text-right">
                    <ion-label position="static">
                        Picked: {{ line.qty_picked }}
                        <small v-if="line.picker">
                            (By {{ line.picker.initials }})
                        </small>
                    </ion-label>
                </ion-col>
            </ion-row>
        </ion-grid>
        <big-stepper size="medium" label="Check Quantity" v-model="quantity"/>
    </div>
</template>

<script>
import {
    IonLabel, IonRow, IonCol, IonGrid
} from '@ionic/vue';

import BigStepper from "@/components/BigStepper";
import {closeOutline, search, barcode, checkmarkCircle} from 'ionicons/icons';
import { computed } from 'vue'
export default {
    props: {line: Object, modelValue: Number},
    inject: ['$http', '$toast', '$validationAlert'],
    emits: ['update:modelValue'],
    name: 'CheckQuantity',
    components: {
        BigStepper, IonLabel, IonRow, IonCol, IonGrid
    },
    methods: {},
    data() {
        return {
            qty_checked: this.line.qty_checked
        }
    },
    setup(props, {emit}) {
        // Explanation of how to get v-model working in Vue 3:
        // https://www.vuemastery.com/blog/vue-3-data-down-events-up/
        const quantity = computed({
            get: () => props.modelValue,
            set: (value) => emit('update:modelValue', value)
        });
        return {
            quantity,
            checkmarkCircle,
            barcode,
            search,
            closeOutline
        };
    }
}
</script>

<style scoped>
  ion-label {
    text-align: center;
  }
</style>
